/** @format */

import { toRegexp, toPath } from "@riotjs/route";
import information from "@tags/pages/menu/information.riot";
import informationDetail from "@tags/pages/menu/information-detail.riot";
import registerCompany from "@tags/pages/menu/register-company.riot";
import registerIndividual from "@tags/pages/menu/register-individual.riot";
import top from "@tags/pages/menu/top.riot";
import member from "@tags/pages/menu/member.riot";
import aboutRole from "@tags/pages/menu/about-role.riot";
import companyInfo from "@tags/pages/menu/company-info.riot";
import rules from "@tags/pages/menu/rules.riot";
import faq from "@tags/pages/menu/faq.riot";
import inquiry from "@tags/pages/menu/inquiry.riot";
import invoice from "@tags/pages/menu/invoice.riot";
import order from "@tags/pages/menu/order.riot";
import permissionError from "@tags/pages/menu/permission-error.riot";

const pages = [
  {
    path: "/menu/permission-error",
    is: "permission-error-tag",
    component: permissionError,
  },
  {
    path: "/menu",
    is: "top-tag",
    component: top,
  },
  {
    path: "/menu/company-info",
    is: "company-info-tag",
    component: companyInfo,
  },
  {
    path: "/menu/register-company",
    is: "register-company-tag",
    component: registerCompany,
  },
  {
    path: "/menu/register-individual",
    is: "register-individual-tag",
    component: registerIndividual,
  },
  {
    path: "/menu/member",
    is: "member-tag",
    component: member,
  },
  {
    path: "/menu/about-role",
    is: "about-role-tag",
    component: aboutRole,
  },
  {
    path: "/menu/information",
    is: "information-tag",
    component: information,
  },
  {
    path: "/menu/information/detail/:info_id",
    is: "information-detail-tag",
    component: informationDetail,
  },
  {
    path: "/menu/rules",
    is: "rules-tag",
    component: rules,
  },
  {
    path: "/menu/faq",
    is: "faq-tag",
    component: faq,
  },
  {
    path: "/menu/inquiry",
    is: "inquiry-tag",
    component: inquiry,
  },
  {
    path: "/menu/invoice",
    is: "invoice-tag",
    component: invoice,
  },
  {
    path: "/menu/order",
    is: "order-tag",
    component: order,
  },
];

for (const page of pages) {
  page.route = toRegexp(page.path, [], { endsWith: "([#?].*)?" });
}

const routes = {
  pages,
  makePath: (name, param) =>
    toPath(pages.find((v) => v.is == name).path, param),
};

export default routes;
